var ctDialogComponent;
(function ($) {
 	$.fn.capitechDialog = function() {
		var $ctDialogElm = $(this);
		var options = {}
		var permissionsAndRegistrationSetup;
		
		// functions
		/*////////////////////////////////////////////////////////////*/
		function init() {
			permissionsAndRegistrationSetup = getLocalStorage('myCapitechPermissionsAndRegistrationSetup');
			ctDialogComponent = new dialogViewModel();
			$('*[data-ko-bind="ctDialogComponent"]').each(function(index, obj) {
				ko.applyBindings(ctDialogComponent, obj);
			});
			ctDialogComponent.getThreads(50,0);
		}
		
		function updateUnReadCount() {
			var unReadMessageCount = 0;
			ko.utils.arrayForEach(ctDialogComponent.threads(), function(thread) {
				unReadMessageCount += thread.incomingMessagesCount() - thread.acknowledgeCount();
			});
			setLocalStorage('myCapitechUnReadMessageCount', unReadMessageCount);
			ctUnreadMessagesModel.unreadMessageCount(unReadMessageCount);
		}
		
		$(window).resize(function(event) {
			var $activeThread = $('.ct-dialog-thread.active');
			if ($activeThread) {
				calculateAndFixSizes($activeThread);
			}
		});
		
		// Models
		/*////////////////////////////////////////////////////////////*/
		var dialogViewModel = function() {
			var self = this;
			
			self.threads = ko.observableArray();
			self.selectedThread = ko.observable(new threadViewModel());
			self.newThreadMessageOpenForm = function() {
				$.magnificPopup.open({
					mainClass: 'dialog-slide-bottom',
					closeOnBgClick: false,
					items: {
						src: $('#ct-dialog-compose'),
						type: 'inline'
					},
					callbacks: {
						beforeOpen: function() {
							_api.getDepartmentDescriptions_POST(
								function(data, textStatus, jqXHR) {
									var newItems = ko.utils.arrayMap(data.content, function(item) {
										return new departmentViewModel(item.description, item.value);
									});
									self.departments.removeAll();
									self.departments.push.apply(self.departments, newItems);
									// Get and set default department
									setDefaultEmployeeDepartment(self);
									// Refresh select2 
									$('select#departmentId').each(function(index, el){
										$(el).data('select2').$container.find('*').addClass('needsclick');
									});
								},
								function(jqXHR, textStatus, errorThrown) {
									sweetAlert(getResource('app.apiTimeoutTitle'), getResource(textStatus), "error");
								},
								getCookie(ACCESSTOKEN_COOKIE_NAME)
							)
						},
						open: function() {
							var $thisElm = $(this.container[0]);
							initializeComponents($thisElm);
							// Translate labels
							translateGUI($thisElm);
							
							// Init select2
							$('select#departmentId').select2({
								theme: "bootstrap",
								templateResult: function(result, container) {
									if (!result.id) {
										return result.text;
									}
									$(container).addClass('needsclick');
									return result.text;
								}
							});
						}
					}
				});
			}
			self.departments = ko.observableArray();
			self.newThreadMessageDepartmentId = ko.observable();
			self.newThreadMessage = ko.observable(new messageViewModel());
			self.newThreadMessageSubmit = function() {
				var success = function success(data, textStatus, jqXHR) {
					// Hide loader
					loaderIndicator(false);
					if (data.success == true) {
						var receiverNames = [];
						
						$.each(ctDialogComponent.departments(), function (i, item) {
							if (item.value() == 50) {
								receiverNames = item.description();
							}
						});
						
						// Hide loader
						var newThread = new threadViewModel({
							id: data.content[0].threadId,
							topic: self.newThreadMessage().subject(),
							incomingMessagesCount: 0,
							isIncoming: false,
							isOutgoing: true,
							createdOn: moment().format(),
							lastMessageCreatedOn: moment().format(),
							startedById: permissionsAndRegistrationSetup.id,
							startedBy: permissionsAndRegistrationSetup.name,
							receiverNames: [receiverNames],
							dialogType: 'Department'
						});
						var newMessage = new messageViewModel({
							id: data.content[0].messageId,
							threadId: data.content[0].threadId,
							topic: self.newThreadMessage().subject(),
							body: self.newThreadMessage().body(),
							senderFullName: permissionsAndRegistrationSetup.name
						});
						
						newThread.messages().push(newMessage);
						self.threads.unshift(newThread);
						if ($('body').width() >= 800) {
							$('.ct-dialog-threads li').first().trigger('click');
						}
						$.magnificPopup.close();
					} else {
						sweetAlert(getResource('app.informationTitle'), handleServerErrorMessage(data.displayErrorMessage), "error");
					}
				};
				var error = function error(jqXHR, textStatus, errorThrown) {
					// Hide loader
					loaderIndicator(false);
					sweetAlert("Error", errorThrown, "error");
				};
				// Show loader
				loaderIndicator(true);
				_api.startDialog_POST(success, error, ctDialogComponent.newThreadMessageDepartmentId(), ctDialogComponent.newThreadMessage().subject(), ctDialogComponent.newThreadMessage().body(), getCookie(ACCESSTOKEN_COOKIE_NAME), null, null);
			}
			self.dialogMessageTemplate = ko.computed(function() {
				return 'defaultIncomingTemplate';
			});
			self.getThreads = function(take, skip) {
				var success = function success(data, textStatus, jqXHR) {
					// Hide loader
					loaderIndicator(false);
					if (data.success == true) {
						$.each(data.content, function(i, obj) {
							ctDialogComponent.threads.push(new threadViewModel(obj));
						});
						updateUnReadCount();
					} else {
						sweetAlert(getResource('app.informationTitle'), handleServerErrorMessage(data.displayErrorMessage), "error");
					}
				};
				var error = function error(jqXHR, textStatus, errorThrown) {
					// Hide loader
					loaderIndicator(false);
					sweetAlert("Error", errorThrown, "error");
				};
				// Show loader
				loaderIndicator(true);
				_api.getDialogs_POST(success, error, take, skip, getCookie(ACCESSTOKEN_COOKIE_NAME));
			}
			self.sortThreads = function() {
				// Sort thread array
				self.threads.sort(_sortByLastMessageCreatedOnDESC);
			}
		}
		
		var threadViewModel = function(properties) {
			// properties
			if(typeof(properties)==='undefined')									properties									= {};
			if(typeof(properties.id)==='undefined')									properties.id								= '';
			if(typeof(properties.createdOn)==='undefined')							properties.createdOn						= '';
			if(typeof(properties.lastMessageCreatedOn)==='undefined')				properties.lastMessageCreatedOn 			= '';
			if(typeof(properties.startedById)==='undefined')						properties.startedById						= '';
			if(typeof(properties.startedBy)==='undefined')							properties.startedBy						= '';
			if(typeof(properties.topic)==='undefined')								properties.topic							= '';
			if(typeof(properties.isOutgoing)==='undefined')							properties.isOutgoing						= true;
			if(typeof(properties.isIncoming)==='undefined')							properties.isIncoming						= false;
			if(typeof(properties.outgoingMessagesCount)==='undefined')				properties.outgoingMessagesCount			= '';
			if(typeof(properties.incomingMessagesCount)==='undefined')				properties.incomingMessagesCount			= '';
			if(typeof(properties.acknowledgeCount)==='undefined')					properties.acknowledgeCount					= 0;
			if(typeof(properties.messages)==='undefined')							properties.messages							= [];
			if(typeof(properties.unReadMessagesCount)==='undefined')				properties.unReadMessagesCount				= 0;
			if(typeof(properties.dialogType)==='undefined')							properties.dialogType						= 'Department';
			if(typeof(properties.hasUnAcknowledgedMessages)==='undefined')			properties.hasUnAcknowledgedMessages		= false;
			if(typeof(properties.receiverNames)==='undefined')						properties.receiverNames					= [];
			
			var self = this;
			self.id									= ko.observable(properties.id);
			self.createdOn							= ko.observable(properties.createdOn);
			self.lastMessageCreatedOn				= ko.observable(properties.lastMessageCreatedOn);
			self.startedById						= ko.observable(properties.startedById);
			self.startedBy							= ko.observable(properties.startedBy);
			self.topic								= ko.observable(properties.topic);
			self.isOutgoing							= ko.observable(properties.isOutgoing);
			self.isIncoming							= ko.observable(properties.isIncoming);
			self.outgoingMessagesCount				= ko.observable(properties.outgoingMessagesCount);
			self.incomingMessagesCount				= ko.observable(properties.incomingMessagesCount);
			self.acknowledgeCount					= ko.observable(properties.acknowledgeCount);
			self.messages							= ko.observableArray(properties.messages);
			self.unReadMessagesCount				= ko.observable(properties.unReadMessagesCount);
			self.dialogType							= ko.observable(properties.dialogType);
			self.hasUnAcknowledgedMessages			= ko.observable(properties.hasUnAcknowledgedMessages);
			self.receiverNames						= ko.observable(properties.receiverNames.join(', '));
			self.newMessageContent					= ko.observable('');
			self.lastMessageCreatedOnUnixTimestamp	= ko.pureComputed(function(){
				return moment(self.lastMessageCreatedOn()).unix();
			}, self);
			self.startedByOrStartedById 			= ko.pureComputed(function(){
				if (self.startedBy() !== '') {
					return self.startedBy();
				} 
				return self.startedById();
			}, self);
			self.markupClasses = ko.pureComputed(function() {
				var retClasses = '';
				if (self.isIncoming()) {
					retClasses = 'ct-dialog-incoming';
				} else {
					retClasses = 'ct-dialog-outgoing';
				}
				if (self.unReadMessagesCount() > 0) {
					retClasses = retClasses + ' ct-dialog-unread';
				} else {
					retClasses = retClasses + ' ct-dialog-read';
				}
				if (self.hasUnAcknowledgedMessages()) {
					retClasses = retClasses + ' ct-dialog-unacknowledged';
				} else {
					retClasses = retClasses + ' ct-dialog-acknowledged';
				}
				return retClasses;
			}, self);
			self.iconMarkupClasses = ko.pureComputed(function() {
				if (self.dialogType() == 'Employee') {
					return 'ct-icon-person-tall';
				} else if (self.dialogType() == 'Group') {
					return 'ct-icon-group';
				} else if (self.dialogType() == 'Department') {
					return 'ct-icon-department';
				}
			}, self);
			self.clickActionOpenThread = function(thread, event) {
				var $this = $((event.currentTarget) ? event.currentTarget : event.srcElement);
				if ($this.hasClass('active') === false) {
					self.getMessages(50, 0, thread, $this);
				} else {
					self.toggleThreadActive($this);
					self.calculateAndFixSizes($this);
				}
			};
			self.getMessages = function(take, skip, thread, $selectedThreadObj) {
				var success = function success(data, textStatus, jqXHR) {
					var acknowledgedMessages = 0;
					// Hide loader
					loaderIndicator(false);
					if (data.success == true) {
						self.messages.removeAll();
						$.each(data.content, function(i, obj) {
							self.messages.push(new messageViewModel(obj));
						});
						// Count acknowledged messages and update thread
						ko.utils.arrayForEach(self.messages(), function(message) {
							if (!message.isUnAcknowledged() && message.isIncoming()) {
								acknowledgedMessages++
							}
						});
						self.acknowledgeCount(acknowledgedMessages);
						if (self.incomingMessagesCount() == self.acknowledgeCount()) {
							self.hasUnAcknowledgedMessages(false);
						}
						// Sort messages
						self.messages.sort(_sortByCreatedOnASC);
						// Activate clicked thread
						ctDialogComponent.selectedThread(self);
						setTimeout(function () {
							thread.unReadMessagesCount(0);
							self.toggleThreadActive($selectedThreadObj);
							self.calculateAndFixSizes($selectedThreadObj);
						}, 50);
						updateUnReadCount();
					} else {
						sweetAlert(getResource('app.informationTitle'), handleServerErrorMessage(data.displayErrorMessage), "error");
					}
				};
				var error = function error(jqXHR, textStatus, errorThrown) {
					// Hide loader
					loaderIndicator(false);
					sweetAlert("Error", errorThrown, "error");
				};
				// Show loader
				loaderIndicator(true);
				_api.getDialogMessages_POST(success, error, self.id(), take, skip, getCookie(ACCESSTOKEN_COOKIE_NAME));
			};
			self.clickActionAcknowledgeAllMessages = function(thread) {
				var success = function success(data, textStatus, jqXHR) {
					// Hide loader
					loaderIndicator(false);
					if (data.success == true) {
						self.incomingMessagesCount(0);
					} else {
						sweetAlert(getResource('app.informationTitle'), handleServerErrorMessage(data.displayErrorMessage), "error");
					}
				};
				var error = function error(jqXHR, textStatus, errorThrown) {
					// Hide loader
					loaderIndicator(false);
					sweetAlert("Error", errorThrown, "error");
				};
				// Loop unread messages
				ko.utils.arrayForEach(thread.messages(), function(message) {
					// Show loader
					loaderIndicator(true);
					_api.confirmMessage_POST(success, error, thread.id(), message.id(), getCookie(ACCESSTOKEN_COOKIE_NAME));
				});
			};
			self.clickActionReply = function(selectedThread) {
				var acknowledgeRequiredBeforeReply = false;
				var success = function success(data, textStatus, jqXHR) {
					// Hide loader
					loaderIndicator(false);
					$('#ct-dialog-reply-textarea').prop('disabled', false);
					$('#ct-dialog-button-reply-thread').prop('disabled', false);
					if (data.success == true) {
						self.messages.push(new messageViewModel({
							id: data.content,
							threadId: selectedThread.id(),
							body: selectedThread.newMessageContent(),
							senderUsername: permissionsAndRegistrationSetup.id,
							senderFullName: permissionsAndRegistrationSetup.name
						}));
						self.newMessageContent('');
						self.calculateAndFixSizes($('.ct-dialog-thread.active'));
						
						// Update thread last message date
						selectedThread.lastMessageCreatedOn(moment().format());
						ctDialogComponent.sortThreads();
					} else {
						sweetAlert(getResource('app.informationTitle'), handleServerErrorMessage(data.displayErrorMessage), "error");
					}
				};
				var error = function error(jqXHR, textStatus, errorThrown) {
					// Hide loader
					loaderIndicator(false);
					$('#ct-dialog-reply-textarea').prop('disabled', false);
					$('#ct-dialog-button-reply-thread').prop('disabled', false);
					sweetAlert("Error", errorThrown, "error");
				};
				
				ko.utils.arrayForEach(selectedThread.messages(), function(message) {
					if (message.isUnAcknowledged()) {
						acknowledgeRequiredBeforeReply = true;
					}
				});
				
				if (acknowledgeRequiredBeforeReply) {
					sweetAlert(getResource('dialog.acknowledgeRequiredTitle', 'Acknowledge required'), getResource('dialog.acknowledgeRequiredText', 'You have one or more messages that you need to confirm that you have read, please confirm these before replying.'), 'info');
				} else {
					// Show loader
					$('#ct-dialog-reply-textarea').prop('disabled', true);
					$('#ct-dialog-button-reply-thread').prop('disabled', true);
					loaderIndicator(true);
					_api.sendInDialog_POST(success, error, selectedThread.id(), selectedThread.newMessageContent(), getCookie(ACCESSTOKEN_COOKIE_NAME));
				}
				
			};
			self.toggleThreadActive = function($this) {
				toggleThreadActive($this);
			}
			self.calculateAndFixSizes = function($this) {
				calculateAndFixSizes($this);
			};
		};
		
		var messageViewModel = function(properties) {
			// properties
			if(typeof(properties)==='undefined')							properties							= {};
			if(typeof(properties.id)==='undefined')							properties.id						= '';
			if(typeof(properties.threadId)==='undefined')					properties.threadId					= '';
			if(typeof(properties.createdOn)==='undefined')					properties.createdOn				= moment().format();
			if(typeof(properties.readOn)==='undefined')						properties.readOn					= '';
			if(typeof(properties.subject)==='undefined')					properties.subject					= '';
			if(typeof(properties.body)==='undefined')						properties.body						= '';
			if(typeof(properties.senderUsername)==='undefined')				properties.senderUsername			= '';
			if(typeof(properties.senderFullName)==='undefined')				properties.senderFullName			= '';
			if(typeof(properties.isOutgoing)==='undefined')					properties.isOutgoing				= true;
			if(typeof(properties.isIncoming)==='undefined')					properties.isIncoming				= false;
			if(typeof(properties.createdOnUnixTimestamp)==='undefined')		properties.createdOnUnixTimestamp	= moment(properties.createdOn).unix();
			if(typeof(properties.isUnAcknowledged)==='undefined')			properties.isUnAcknowledged			= false;
			
			var self = this;
			self.id							= ko.observable(properties.id);
			self.threadId					= ko.observable(properties.threadId);
			self.createdOn					= ko.observable(properties.createdOn);
			self.readOn						= ko.observable(properties.readOn);
			self.subject					= ko.observable(properties.subject);
			self.body						= ko.observable(properties.body);
			self.senderUsername				= ko.observable(properties.senderUsername);
			self.senderFullName				= ko.observable(properties.senderFullName);
			self.isOutgoing					= ko.observable(properties.isOutgoing);
			self.isIncoming					= ko.observable(properties.isIncoming);
			self.createdOnUnixTimestamp		= ko.observable(properties.createdOnUnixTimestamp);
			self.isUnAcknowledged			= ko.observable(properties.isUnAcknowledged);
			self.dialogMessageTemplate		= ko.computed(function() {
				return 'defaultIncomingTemplate';
			});
			self.senderFullNameOrSenderUsername = ko.pureComputed(function(){
				if (self.senderFullName() !== '') {
					return self.senderFullName();
				} 
				return self.senderUsername();
			}, self);
			self.markupClasses = ko.pureComputed(function() {
				var retClasses = "";
				if (self.isOutgoing()) {
					retClasses = 'ct-dialog-message-outgoing outgoing';
				} else {
					retClasses =  'ct-dialog-message-incoming incoming';
					if (self.isUnAcknowledged()) {
						retClasses = retClasses + ' ct-dialog-message-unacknowledged'
					} else {
						retClasses = retClasses + ' ct-dialog-message-acknowledged'
					}
				}
				return retClasses;
			}, self);
			self.createdOnAsDescription = ko.pureComputed(function() {
				if (moment().format('DD-MM-YYYY') == moment(self.createdOn()).format('DD-MM-YYYY')) {
					return moment(self.createdOn()).from();
				} else {
					return moment(self.createdOn()).format('ddd L LT');
				}
			}, self);
			
			self.clickActionAcknowledgeMessage = function(message) {
				var success = function success(data, textStatus, jqXHR) {
					// Hide loader
					loaderIndicator(false);
					if (data.success == true) {
						message.isUnAcknowledged(false);
						ctDialogComponent.selectedThread().acknowledgeCount(ctDialogComponent.selectedThread().acknowledgeCount() + 1);
						if (ctDialogComponent.selectedThread().incomingMessagesCount() == ctDialogComponent.selectedThread().acknowledgeCount()) {
							ctDialogComponent.selectedThread().hasUnAcknowledgedMessages(false);
						}
						updateUnReadCount();
					} else {
						sweetAlert(getResource('app.informationTitle'), handleServerErrorMessage(data.displayErrorMessage), "error");
					}
				};
				var error = function error(jqXHR, textStatus, errorThrown) {
					// Hide loader
					loaderIndicator(false);
					sweetAlert("Error", errorThrown, "error");
				};
				// Show loader
				loaderIndicator(true);
				_api.confirmMessage_POST(success, error, null, message.id(), getCookie(ACCESSTOKEN_COOKIE_NAME));
			};
			
			// Updates moment's pretty dates (23 minutes ago… etc.)
			setInterval(function(){
				self.createdOn.notifySubscribers();
			}, 60 * 1000);
		};
		
		var departmentViewModel = function(description, value) {
			// properties
			var self = this;
			self.description = ko.observable(description);
			self.value = ko.observable(value);
		};
		
		function toggleThreadActive($this) {
			var $body = $('body');
			var $reply = $('.ct-dialog-reply');
			
			if ($this.hasClass('active') === false) {
				$reply.find('textarea').removeClass('active');
				$reply.find('.ct-dialog-reply').removeClass('reply-active');
				$('li.ct-dialog-thread.active').removeClass('active');
				$reply.addClass('active');
				$this.addClass('active');
			} else {
				$this.removeClass('active');
				$body.removeClass('ct-overflow-scroll');
				$('li.ct-dialog-thread.active ul.ct-dialog-thread-messages').height('');
				$('html').css('cssText', '');
				$body.css('cssText', '');
				$reply.removeClass('active');
			}
		}
		
		function calculateAndFixSizes($this) {
			var $mainWrapper = $('.ct-dialog-threads');
			var $childWrapper = $this.children('ul.ct-dialog-thread-messages');
			var $childMessages = $childWrapper.children();
			var childrenHeight = 0;
			var bOpen = $this.hasClass('active');
			var $reply = $('.ct-dialog-reply');
			var $body = $('body');
			var navHeight = $('#nav').height();
			var subjectHeight = $this.find('.ct-dialog-subject').outerHeight(true);
		
			if (bOpen === false) {
				$childWrapper.css('height', '');
			} else {
				$childMessages.each(function(index, thisChild) {
					$child = $(thisChild);
					
					// Break if we have a message that needs acknowledge
					if ($child.hasClass('ct-dialog-message-unacknowledged')) {
						return false;
					}
					
					childrenHeight += $child.outerHeight(true);
				});
				
				if ($body.width() < 800) {
					$this.css('top', navHeight);
					$this.css('bottom', 0);
					$childWrapper.css('height', 'auto');
					$childWrapper.css('top', navHeight + subjectHeight + 10);
					$childWrapper.css('bottom', $reply.outerHeight(true));
					$body.addClass('ct-overflow-scroll');
					$('html').css('cssText', 'height: ' + window.innerHeight + 'px !important; position: relative !important; overflow: hidden !important;');
					$body.css('cssText', 'height: ' + window.innerHeight + 'px !important; position: relative !important; overflow: hidden !important;');
				} else {
					$childWrapper.css('top', '');
					$childWrapper.css('bottom', '');
					$childWrapper.css('height', $mainWrapper.height() - $reply.outerHeight(true));
					$body.removeClass('ct-overflow-scroll');
					$('html').css('cssText', '');
					$body.css('cssText', '');
				}
				
				$childWrapper.clearQueue().delay(800).animate({
					scrollTop: childrenHeight
				}, 400);
			}
		}
		
		function setDefaultEmployeeDepartment(self) {
			var success = function success(data, textStatus, jqXHR) {
				var modelData = {};
				loaderIndicator(false);
				if (data.success == true) {
					modelData.employeeInformation = data.content[0];
					ctEmployeeInformationModel = ko.viewmodel.fromModel(modelData.employeeInformation);
					self.newThreadMessageDepartmentId(ctEmployeeInformationModel.departmentId());
				} else {
					sweetAlert(getResource('app.informationTitle'), handleServerErrorMessage(data.displayErrorMessage), "error");
				}
			};
			var error = function error(jqXHR, textStatus, errorThrown) {
				loaderIndicator(false);
				sweetAlert("Error", errorThrown, "error");
			};
			loaderIndicator(true);
			_api.getEmployeePersonalInformation_POST(success, error, getCookie(ACCESSTOKEN_COOKIE_NAME));
		}
		
		// Sort functions
		/*////////////////////////////////////////////////////////////*/
		_sortByCreatedOnASC = function(a, b) {
			return a.createdOnUnixTimestamp() < b.createdOnUnixTimestamp() ? -1 : 1;
		};
		_sortByLastMessageCreatedOnDESC = function(a, b) {
			return a.lastMessageCreatedOnUnixTimestamp() > b.lastMessageCreatedOnUnixTimestamp() ? -1 : 1;
		};
		
		// init
		/*////////////////////////////////////////////////////////////*/
		init();
		
	};
}(jQuery));